import { PAGE_TYPE_HOMEPAGE } from 'shared/consts'
import {
  HOME_SERVICE_LINK_CLICK,
  MOBILE_SERVICES_HOMEPAGE,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import isElementInViewport from 'views/utils/isElementInViewport'

export default () => {
  const { isEnabled } = getExperimentOnClient(MOBILE_SERVICES_HOMEPAGE) || {}
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType } = publicRuntimeConfig?.pageProperties || {}
  const serviceLinksContainer = <HTMLElement>(
    document.querySelector('.o-ServiceLinksContainer')
  )

  if (!isEnabled || pageType !== PAGE_TYPE_HOMEPAGE || !serviceLinksContainer) {
    return
  }

  const experimentActivationEvent = () => {
    if (isElementInViewport(serviceLinksContainer)) {
      void activateExperiment(MOBILE_SERVICES_HOMEPAGE)
      document.removeEventListener('scroll', experimentActivationEvent)
    }
  }
  document.addEventListener('scroll', experimentActivationEvent)
  experimentActivationEvent()

  serviceLinksContainer.addEventListener('click', (e: MouseEvent) => {
    const target = <HTMLElement>e.target

    if (target.closest('.o-IconLinksList__item')) {
      trackOptimizelyEvent(HOME_SERVICE_LINK_CLICK)
    }
  })
}
